import React from "react";
import { useHistory } from "react-router-dom";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const CostoFinanciamientoItem = ( {data, sucursales} ) => {
  const history = useHistory();
  const año = new Date().getFullYear();
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickCostoFinanciamiento = () => {
    history.push("/Finanzas/CostoFinanciamiento", sucursales);
  };

  console.log(data?.costoFinanciamiento)
  const costo = data?.costoFinanciamiento

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
};

const calcularporcentaje = (param, ventasNetas) => {
  if (!ventasNetas) return 0;
  return ((param / ventasNetas) * 100).toFixed(2);
};

  return (
    <div className="dashboard-financiero-container-box-2" onClick={handleClickCostoFinanciamiento}>
      <div className="dashboard-financiero-container-box-titulo">
        Costo Integral Financiamiento
      </div>
      <div className="dashboard-financiero-container-box-info df_box_costo_financiamiento">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <td></td>
              <td>{año}</td>
              <td>{año - 1}</td>
              <td>Desviación</td>
            </tr>
          </thead>
          <tbody>
          {costo.map((item, index) => (
              <tr key={index}>
                <td>{capitalizePalabras(item.grupo)}</td>
                <td className="ta-center">{formatmiles(item.real)}</td>
                <td className="ta-center">{formatmiles(item.anterior)}</td>
                <td className="ta-center">{formatmiles(item.anteriordiferencia)} ({item.porcentajeanterior}%)</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
